import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

import SelectInput from '../../inputs/SelectInput';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class CommandPopup extends React.Component {
    state = {
        open: true,
        product: null,
        machine: null,
        units: 0,
    };

    UpdateMachines = (arr, units) => {
        if (arr) {
            const temp = arr.reduce((arr, m) => {
                console.log(m.rangos);
                if (!m.rangos || m.rangos.length === 0) {
                    arr.push(m);
                } else if (m.rangos.some((a) => a.desde <= units && a.hasta >= units)) {
                    arr.push(m);
                }
                return arr;
            }, []);
            const aux = temp && temp.length > 0 ? temp[0] : {};
            const priotiaries = temp && temp.length > 0 ? temp.filter((f) => f.prioritaria) : {};
            const selected = priotiaries && priotiaries.length > 0 ? priotiaries[0] : aux;

            this.setState({
                machines: arr,
                list: temp,
                machine: selected.id ? { value: selected.id, label: selected.nombre } : null,
            });
        }
    };

    handleChangeProces = (event) => {
        this.props.getMachinesProduct(this.props.id, event.value).then((data) => {
            this.UpdateMachines(data, this.state.units);
        });
        this.setState({ product: event });
    };

    handleChangeMachine = (event) => {
        this.setState({ machine: event });
    };

    handleMinus = (event) => {
        const { units, machines } = this.state;
        const value = parseInt(units, 10) - 1;
        this.UpdateMachines(machines, value);

        if (this.state.units > 0) {
            this.setState({ units: value });
        }
    };

    handlePlus = (event) => {
        const { units, machines } = this.state;
        const value = parseInt(units, 10) + 1;
        this.UpdateMachines(machines, value);

        this.setState({ units: value });
    };

    handleChange = (event) => {
        const { machines } = this.state;
        const value = parseInt(event.target.value, 10);
        this.UpdateMachines(machines, value);

        this.setState({ [event.target.name]: event.target.value });
    };

    handleChangeClick = (add) => (event) => {
        //const { units, machines } = this.state;
        //const value = parseInt(units, 10) + add;
        //this.UpdateMachines(machines, value);
        //this.setState({ units: value });

        const { units, machines } = this.state;
        const value = parseInt(units.toString().concat(add), 10);
        this.UpdateMachines(machines, value);
        this.setState({ units: value });
    };

    handleRemoveUnits = (event) => {
        const { machines } = this.state;
        this.UpdateMachines(machines, 0);
        this.setState({ units: 0 });
    }

    isOk = () => {
        const { product, units, machine } = this.state;
        return product && units > 0 && machine;
    };

    handleSummit = () => {
        const { product, units, machine } = this.state;
        this.props
            .addProduction({
                idLocal: this.props.id,
                idProducto: product.value,
                cantidad: units,
                idMaquina: machine.value,
            })
            .then(() => this.props.handleClose('command', false))
            .catch((error) => this.props.handleClose('command', error.message));
        this.setState({ open: false });
    };

    render() {
        const { product, machine, units, list, open } = this.state;
        const { handleClose, intl, tag } = this.props;
        const disabled = !this.isOk();
        return (
            <Dialog
                onClose={() => handleClose('command', false)}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableBackdropClick
                classes={{
                    paper: 'xhef_command_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('command', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_command_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <div className="flex_auto_row align_center ">
                                <SelectInput
                                    defaultValue={product}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_waste_products_title',
                                    })}
                                    isNotSearchable
                                    options={this.props.products
                                        .filter((f) => tag === 0 || f.nomEstacion === tag)
                                        .sort((a, b) =>
                                            a.nombre.toUpperCase() < b.nombre.toUpperCase()
                                                ? -1
                                                : 1,
                                        )
                                        .map((p) => {
                                            return { label: p.nombre.toUpperCase(), value: p.id };
                                        })}
                                    onChange={this.handleChangeProces}
                                />
                            </div>
                            <div className="flex_auto_row margin_top_32 align_center">
                                <TextField
                                    required
                                    fullWidth
                                    disabled={true}
                                    name={'units'}
                                    id={'units'}
                                    label={intl.formatMessage({
                                        id: 'xhef_popup_waste_units_title',
                                    })}
                                    value={units}
                                    type="number"
                                    inputProps={{
                                        className: 'barlowcondensed_regular c_black',
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                    }}
                                    onChange={this.handleChange}
                                    className="text_align_center"
                                />
                            </div>
                            <div className="flex_auto_row ">
                                <div className="flex_full_column">
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(0)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            0
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(1)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            1
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(2)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            2
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(3)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            3
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(4)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            4
                                        </Button>
                                    </div>
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(5)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            5
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(6)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            6
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(7)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            7
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(8)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            8
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(9)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            9
                                        </Button>
                                    </div>
                                </div>
                                <Button
                                    onClick={this.handleRemoveUnits}
                                    color="primary"
                                    variant="outlined"
                                    className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                >
                                    {
                                        intl.formatMessage({
                                            id: 'remove',
                                        })
                                    }
                                </Button>
                            </div>
                            {
                                /*
                                <div className="flex_full_row margin_top_32 align_center">
                                    <Button
                                        onClick={this.handleMinus.bind(this)}
                                        variant="contained"
                                        disabled={units <= 0}
                                        className={
                                            'flex_full_row bg_white padding_borders xhef_waste_popup_button_negative'
                                        }
                                        classes={{
                                            disabled: 'xhef_waste_popup_button_negative_disabled',
                                        }}
                                    >
                                        <MinusIcon className={units > 0 ? 'c_bluish' : 'c_white'} />
                                    </Button>
                                    <Button
                                        onClick={this.handlePlus.bind(this)}
                                        variant="contained"
                                        className={
                                            'flex_full_row bg_pea padding_borders xhef_waste_popup_button_positive'
                                        }
                                    >
                                        <AddIcon className="c_white" />
                                    </Button>
                                </div>
                                <div className="flex_full_row center margin_top_32 ">
                                    <Button
                                        onClick={this.handleChangeClick(3)}
                                        color="primary"
                                        className="flex_full_row barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                    >
                                        +3
                                    </Button>
                                    <Button
                                        onClick={this.handleChangeClick(6)}
                                        color="primary"
                                        className="flex_full_row barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                    >
                                        +6
                                    </Button>
                                    <Button
                                        onClick={this.handleChangeClick(12)}
                                        color="primary"
                                        className="flex_full_row barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                    >
                                        +12
                                    </Button>
                                    <Button
                                        onClick={this.handleChangeClick(24)}
                                        color="primary"
                                        className="flex_full_row barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                    >
                                        +24
                                    </Button>
                                </div>
                                */
                            }
                            <div className="flex_auto_row align_center margin_top_32">
                                <SelectInput
                                    defaultValue={machine}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_command_machine_title',
                                    })}
                                    isNotSearchable
                                    options={
                                        list && list.length > 0
                                            ? list.map((m) => {
                                                return { value: m.id, label: m.nombre };
                                            })
                                            : []
                                    }
                                    onChange={this.handleChangeMachine}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            disabled={disabled}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders'}
                            onClick={this.handleSummit}
                        >
                            <FormattedMessage id="xhef_popup_command_button_title" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

CommandPopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CommandPopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/CommandPopup.js